import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'

export const ParagraphStyled = styled('p')({
  textAlign: 'left',
  color: colors.neutral[900],
  margin: '0',
  ...font.size.lg,
})

export const ModalContentStyled = styled('div')({
  color: colors.neutral[800],
  margin: spacing.smx1,
  ...font.size.lg,
})
